function DefaulLayout({ children }) {
  return <>{children}</>;
}

export default DefaulLayout;
